import {
  Component,
  EventEmitter,
  Input, OnInit,
  Output,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DEFAULT_SIZE_ID } from '../../../models/organization.model';
import { Helpers } from 'app/helpers/helpers';
import { ICartModifier, ICartProduct } from 'app/models/cart.model';

@UntilDestroy()
@Component({
  selector: 'app-checkbox-select[modifier][groupIsMaxFull]',
  templateUrl: './checkbox-select.component.html',
  styleUrls: ['./checkbox-select.component.scss']
})
export class CheckboxSelectComponent implements OnInit {

  @Input() modifier: ICartModifier;
  @Output() modifierChange: EventEmitter<ICartModifier> = new EventEmitter();
  @Input() cartProduct: ICartProduct;

  @Output() notifyChange: EventEmitter<any> = new EventEmitter();

  @Input() groupIsMaxFull: boolean;
  @Input() productSizeId: string | null = DEFAULT_SIZE_ID;
  checked = false;

  constructor() {
  }

  ngOnInit(): void {
    this.modifier.calculatedPrice = Helpers.calculatePriceModifier(this.modifier, this.productSizeId);
  }

  checkboxChange(checked: boolean): any {
    this.modifier.selectedQuantity = checked ? 1 : 0;
    this.notifyChange.emit();
  }
}
